export interface PdfLogo {
  dataUrl: string;
  format: 'PNG' | 'JPEG';
  width: number;
  height: number;
}

export async function loadLogoForPdf(url: string): Promise<PdfLogo | undefined> {
  try {
    const response = await fetch(url);
    if (!response.ok) {
      return undefined;
    }
    const blob = await response.blob();
    if (!blob.type.startsWith('image/')) {
      return undefined;
    }
    const dataUrl = await blobToDataUrl(blob);
    const dimensions = await readImageDimensions(dataUrl);
    return {
      dataUrl,
      format: blob.type === 'image/png' ? 'PNG' : 'JPEG',
      width: dimensions.width,
      height: dimensions.height,
    };
  } catch {
    return undefined;
  }
}

function blobToDataUrl(blob: Blob): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result));
    reader.onerror = () => reject(reader.error);
    reader.readAsDataURL(blob);
  });
}

function readImageDimensions(dataUrl: string): Promise<{ width: number; height: number }> {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.onload = () => resolve({ width: image.naturalWidth, height: image.naturalHeight });
    image.onerror = () => reject(new Error('Failed to load logo image'));
    image.src = dataUrl;
  });
}
